import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { brandingApi } from '../services/branding'
import { authApi } from '../services/auth'
import { rtkQueryErrorLogger } from '../services/errorMidlaware'
import errorSlice from './ErrorSlice'

const rootReducer = combineReducers({
  brandingApi: brandingApi.reducer,
  authApi: authApi.reducer,
  errorSlice: errorSlice,
})

const apiConfigured = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(brandingApi.middleware)
      .concat(authApi.middleware)
      .concat(rtkQueryErrorLogger),
})

export default apiConfigured
